import { SET_MESSAGE_COUNT, SET_MESSAGE_LIST } from "../actions/message";

const initialState = {
  messageCount: {
    category: {},
    kind: {},
    total: 0,
    count: 0,
    jobApplicationMsgCount: 0,
  },
  messageList: null,
};

const applicationMsgKinds = [
  // "job_application_contact_pending",
  "job_application_rejected",
  // "job_application_expired",
  "job_application_qualified",
];

const employerMsgKinds = ["post_approved", "post_rejected"];

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_MESSAGE_COUNT:
      return {
        ...state,
        messageCount: {
          ...action.count,
          jobApplicationMsgCount: applicationMsgKinds.reduce(
            (acc, kind) => acc + _.get(action.count.kind, kind, 0),
            0
          ),
          employerMsgCount: employerMsgKinds.reduce(
            (acc, kind) => acc + _.get(action.count.kind, kind, 0),
            0
          ),
        },
      };
    case SET_MESSAGE_LIST:
      return {
        ...state,
        messageList: action.list,
      };
    default:
      return state;
  }
};
